module.exports = __webpack_public_path__ + "img/categories_engagement_mobile_all@2x.b509156.webp";